export default __webpack_public_path__ + "static/media/addFilter.a76cb16b.svg";